import { BrandLogo } from '@repo/ui/components/brand-logo';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/components/card';
import { useT } from '../locales/context';

export function CheckEmail() {
  const t = useT();
  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        <BrandLogo size={40} />
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>{t.auth.checkEmailTitle}</CardTitle>
            <CardDescription>{t.auth.checkEmailSubtitle}</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">{t.auth.checkEmailBody}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
